import { Injectable, Type } from "@angular/core";
import { ConfigService } from "../../../services/config.service";
import { CommonService, FeatureFlagService, Shared } from "@rubii/frontend-common";
import { Params, Router } from "@angular/router";
import { BaseSaveConfigHandler } from "../classes/base-save-config-handler.class";
import { ValidateParams } from "../decorators/params-validator.decorator";
import { MatDialog } from "@angular/material/dialog";
import { Dictionary } from "@rubii/frontend-common/lib/models/common/Dictionary";
import { BaseDatasourceComponent } from "../base-datasource/base-datasource.component";
import { CriteoComponent } from "../criteo/criteo.component";
import { ClientService } from "../../../services/client.service";
import { Dsps } from "@rubii/share/src/constants";
import { DatasourceConnectionComponent } from "../../datasource-connection/datasource-connection.component";

@Injectable({
    providedIn: "root",
})
export class SaveConfigService {
    constructor(
        private config: ConfigService,
        private client: ClientService,
        private feature: FeatureFlagService,
        private router: Router,
        private dialog: MatDialog
    ) { }

    getHandler(shortName: string): BaseSaveConfigHandler {
        return this[shortName];
    }

    in(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        const input = {
            code: params.code,
        };
        this.client.account.saveINConfig(input).then(ret => {
            openSnackBar(snackBar, "LinkedIn connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
        
    }

    twitter(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        const input = {
            accessToken: params.oauth_token,
            tokenVerifier: params.oauth_verifier,
        };
        this.client.account.exchangeTwitterAccessToken(input).then(ret => {
            openSnackBar(snackBar, "Twitter connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    snapchat(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            code: params.code,
            state: params.state,
            dataSourceId: Shared.dicts.DataSources.SNAPCHAT,
        };
        this.client.account.fetchSnapchatAccessToken(input).then(ret => {
            openSnackBar(snackBar, "Snapchat connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    tiktok(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            code: params.auth_code,
            dataSourceId: Shared.dicts.DataSources.TikTok,
            state: params.state,
        };
        this.client.account.fetchAndSaveTikTokAccessToken(input).then(ret => {
            openSnackBar(snackBar, "TikTok connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
        
    }

    saveGAConfig(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        let input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.GA,
            state: params.state,
        };
        this.client.account.saveGAToken(input).then(ret => {
            openSnackBar(snackBar, "Google Analytics connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    saveSEOConfig(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        let input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.SEO,
            state: params.state,
        };
        this.client.account.fetchAndSaveSeoToken(input).then(ret => {
            openSnackBar(snackBar, "Google SEO connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    youtubeorganic(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        let input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.YOUTUBEORGANIC,
            state: params.state,
        };
        this.client.account.saveYoutubeOrganicToken(input).then(ret => {
            openSnackBar(snackBar, "Youtube Organic connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    yahoo(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            dataSourceId: Shared.dicts.DataSources.YAHOO,
            code: params.code,
            state: params.state,
        };
        this.client.account.saveYahooToken(input).then(ret => {
            openSnackBar(snackBar, "Yahoo Native connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    reddit(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            dataSourceId: Shared.dicts.DataSources.REDDIT,
            code: params.code,
            state: params.state,
        };
        this.client.account.saveRedditToken(input).then(ret => {
            openSnackBar(snackBar, "Reddit connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    spotify(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            dataSourceId: Shared.dicts.DataSources.SPOTIFY,
            code: params.code,
            state: params.state,
        };
        this.client.account.saveSpotifyToken(input).then(ret => {
            openSnackBar(snackBar, "Spotify connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
        
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    tiktokorganic(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {

        const input = {
            dataSourceId: Shared.dicts.DataSources.TIKTOKORGANIC,
            code: params.code,
            state: params.state,
        };
        this.client.account.saveTiktokOrganicToken(input).then(ret => {
            openSnackBar(snackBar, "TikTok Organic connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });

    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    pinterest(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        const input = {
            dataSourceId: Shared.dicts.DataSources.PINTEREST,
            code: params.code,
            state: params.state,
        };
        this.client.account.savePinterestToken(input).then(ret => {
            openSnackBar(snackBar, "Pinterest connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
        
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    criteo(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const data = {
            saveFunction: (currency: string, timezone: string, callback) => {
                this.client.account.saveCriteoToken({
                    dataSourceId: Shared.dicts.DataSources.CRITEO,
                    code: params.code,
                    state: params.state,
                    currency,
                    timezone,
                }).then(ret => {
                    openSnackBar(snackBar, "Criteo connected.", action);
                    getDataSources();
                    if (callback) {
                        callback();
                    }
                }).catch(e => {
                    openSnackBarWarning(snackBar, e.message, action);
                    getDataSources();
                });
            },
        };
        this.openDialog(CriteoComponent, data);
    }

    bing(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        const input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.BINGADS,
            state: params.state,
        };
        this.client.account.saveBingConfig(input).then(ret => {
            openSnackBar(snackBar, "Bing Ads connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    openDialog(
        dataSourcePopupComponent: Type<BaseDatasourceComponent>,
        dict?: any
    ) {
        this.dialog.open(dataSourcePopupComponent, {
            data: dict,
            disableClose: true,
        });
    }

    apple(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        const input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.APPLE,
            state: params.state,
        };
        this.client.account.fetchAndSaveAppleToken(input).then(ret => {
            openSnackBar(snackBar, "Apple search ads is connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    hubspot(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        
        const input = {
            dataSourceId: Shared.dicts.DataSources.HUBSPOT,
            code: params.code,
            state: params.state,
        };
        this.client.account.saveHubspotToken(input).then(ret => {
            openSnackBar(snackBar, "Hubspot connected.", action);
            getDataSources();
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });
        
    }

    @ValidateParams({
        requiredFields: ["code"],
        paramsIndex: 0,
        openSnackBarFuncIndex: 3,
        snackBarParamIndex: 4,
    })
    xero(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {
        // Construct the full URL with query parameters
        const currentUrl = window.location.href;
        
        // Fetch tenants and open dialog
        this.client.account.fetchTokenAndTenants(currentUrl)
            .then(tenants => {
                if (tenants && tenants.length > 0) {
                    // Import XeroComponent dynamically to avoid circular dependency
                    import('../xero/xero.component').then(({ XeroComponent }) => {
                        const dialogRef = this.dialog.open(DatasourceConnectionComponent, {
                            data: { 
                                dataSourceId: Shared.dicts.DataSources.XERO,
                                dataSourceClass: XeroComponent,
                                tenants: tenants
                            }
                        });
                        
                        dialogRef.afterClosed().subscribe(() => {
                            getDataSources();
                        });
                    });
                } else {
                    openSnackBarWarning(snackBar, "No Xero organizations found", action);
                    getDataSources();
                }
            })
            .catch(e => {
                openSnackBarWarning(snackBar, e.message, action);
                getDataSources();
            });
    }

    yahoojp(
        params: Params,
        getDataSources: () => void,
        openSnackBar: (snackBar: any, message: string, action?: string) => void,
        openSnackBarWarning: (
            snackBar: any,
            message: string,
            action?: string
        ) => void,
        snackBar: any,
        action: string = "close"
    ) {

        const input = {
            code: params.code,
            dataSourceId: Shared.dicts.DataSources.YAHOOJP,
            state: params.state,
        };
        this.client.account.fetchTokenAndBaseAccount(input).then((baseAccount: []) => {
            if (!baseAccount || baseAccount.length === 0) {
                openSnackBarWarning(snackBar, "No baseaccounts found", action);
                getDataSources();
            } else {
                 import('../yahoojp/yahoojp.component').then(({ YahoojpComponent }) => {
                        const dialogRef = this.dialog.open(DatasourceConnectionComponent, {
                            data: {
                                dataSourceId: Shared.dicts.DataSources.YAHOOJP,
                                dataSourceClass: YahoojpComponent,
                                baseAccounts: baseAccount
                            }
                        });

                        dialogRef.afterClosed().subscribe(() => {
                            openSnackBar(snackBar, "Yahoo! Japan Ads connected.", action);
                            getDataSources();
                        });
                    });
            }
        }).catch(e => {
            openSnackBarWarning(snackBar, e.message, action);
            getDataSources();
        });

    }
}
